import FindInPageIcon from '@material-ui/icons/FindInPage';
import SeoCheckerList from './SEOCheckerList';
import SeoCheckerShow from './SEOCheckerShow';

export default {
  list: SeoCheckerList,
  show: SeoCheckerShow,
  icon: FindInPageIcon,
};
